<template>
    <div class="help-page">
        <center>
            <div class="help-layout">
                <div class="help-sidebar">
                    <div class="left-nag">
                        <a href="#introduce" style="text-decoration: none;">
                            <span class="left-title">产品介绍</span>
                        </a>
                    </div>
                    <div class="line"></div>
                  <div class="left-nag">
                    <a href="#video" style="text-decoration: none;">
                      <span class="left-title">视频讲解</span>
                    </a>
                  </div>
                  <div class="line"></div>
                    <div class="left-nag" style="margin-bottom: 0px">
                        <a href="#loginAndRegister" style="text-decoration: none;"><span class="left-title">登录注册</span></a>
                    </div>
                    <div class="left-nag-two">
                        <a href="#login" style="text-decoration: none;"><span class="left-title-two">>注册</span></a>
                    </div>
                    <div class="left-nag-two" style="margin-bottom: 20px">
                        <a href="#register" style="text-decoration: none;"><span class="left-title-two">>登录</span></a>
                    </div>
                    <div class="line"></div>
                    <div class="left-nag">
                        <a href="#try" style="text-decoration: none;"><span class="left-title">申请试用</span></a>
                    </div>
                    <div class="line"></div>
                    <div class="left-nag">
                        <a href="#suggest" style="text-decoration: none;"><span class="left-title">意见反馈</span></a>
                    </div>
                    <div class="line"></div>
                    <div class="left-nag">
                        <a href="#translate" style="text-decoration: none;"><span class="left-title">立即翻译</span></a>
                    </div>
                    <div class="line"></div>
                    <div class="left-nag">
                        <a href="#history" style="text-decoration: none;"><span class="left-title">翻译历史</span></a>
                    </div>
                </div>
                <div class="help-content">
                    <div style="margin-top: 27px">
                        <a id="introduce"></a>
                        <div class="main-line"></div>
                        <span class="main-title">
                        产品介绍
                    </span>
                        <div class="main-line"></div>
                    </div>
                    <div>
                        <p class="main-content">
                            微思翻译是基于成熟的机器翻译技术，为广大读者提供多语种在线翻译服务的平台。微思翻译支持对多种格式文档的文档级翻译；是科研工作者、在校研究生及时了解并掌握国外科技文献、前沿讯息的必备工具。具有语种覆盖全面，文件处理安全加密，翻译快速，可批量统一处理文件等特点。
                        </p>
                    </div>
                  <div style="margin-top: 79px">
                    <a id="video"></a>
                    <div class="main-line"></div>
                    <span class="main-title">
                        视频讲解
                    </span>
                    <div class="main-line"></div>
                  </div>
                  <div>
                    <video class="help-video" width="700" height="450" controls>
                      <source src="https://wesitrans.com/wesitrans/template/video/%E5%BE%AE%E6%80%9D%E7%BF%BB%E8%AF%91%E7%AE%80%E4%BB%8B%E8%A7%86%E9%A2%912K.mp4" type="video/mp4">
                    </video>
                  </div>
                    <div style="margin-top: 19px">
                        <a id="loginAndRegister"></a>
                        <div class="main-line"></div>
                        <span class="main-title">
                        登录注册
                    </span>
                        <div class="main-line"></div>
                    </div>
                    <div class="help-subheading" style="margin-top: 10px;margin-left: 60px;text-align: left">
                    <span class="main-title-one">
                         <a id="register"></a>
                        1.注册
                    </span>
                    </div>
                    <div>
                        <p class="main-content">
                            打开微思翻译首页<a href="https://wesitrans.com/index" style="color: #184687;
    text-decoration: none;"> https://wesitrans.com/index</a>点击右上角登录注册按钮，在登录弹窗中点击快捷注册链接，
                            如下图所示：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/rergister-one.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/register-two.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/register-three.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 15px">
                            根据注册规则，输入必填信息，点击注册按钮，即可完成注册。
                        </p>
                        <p class="main-content" style="height: 35px">
                            注册有两种方式，一种方式直接注册成为个人用户；另一种方式在机构管账号登录的情况下注册，成为机构子账号。
                        </p>
                        <p class="main-content" style="text-indent: 0em;">
                            说明：注册完个人账号联系所在的机构，申请加入该机构，成为漫游用户或者ip范围内用户，否则登录后不能使用该产品。（本产品暂时仅对机构账号开放使用）
                        </p>
                    </div>
                    <div class="help-question" style="width: 740px; text-align: left">
                        <div style="
    display: inline-block;
    vertical-align: middle;
    v: common-ligatures;
    position: relative;
    width: 0px;
    height: 0px;
    border-width: 13px;
    border-style: solid;
    border-color: transparent #e4e4e4 transparent transparent;
"></div>
                        <div class="help-question-bubble" style=" display: inline-block;
    vertical-align: middle;
    width: 341px;
    height: 45px;
    background: rgb(228, 228, 228);
    font-size: 14px;
    font-family: Adobe Heiti Std R;
                    line-height: 3.2;
                    text-indent: 1em;
                    text-align: justify;">
                        <span>
                        问：如何判断成为机构子用户（漫游用户）？
                    </span>
                        </div>
                    </div>
                    <div>
                        <p class="main-content" style="height: 15px">
                            答：直接登录注册的个人账号可使用本产品，说明加入机构成功。
                        </p>
                    </div>
                    <div class="help-question" style="width: 740px; text-align: left">
                        <div style="
    display: inline-block;
    vertical-align: middle;
    v: common-ligatures;
    position: relative;
    width: 0px;
    height: 0px;
    border-width: 13px;
    border-style: solid;
    border-color: transparent #e4e4e4 transparent transparent;
"></div>
                        <div class="help-question-bubble" style=" display: inline-block;
    vertical-align: middle;
    width: 341px;
    height: 45px;
    background: rgb(228, 228, 228);
    font-size: 14px;
    font-family: Adobe Heiti Std R;
                    line-height: 3.2;
                    text-indent: 1em;
                    text-align: justify;">
                        <span>
                                 问：如何判断成为机构子用户（ip范围内用户）？
                    </span>
                        </div>

                    </div>
                    <div>
                        <p class="main-content" style="height: 15px">
                            答：打开微思翻译首页，在登录注册按钮旁边显示机构用户名，说明已加入该机构，登录个人账号后，即可使用
                            本产
                        </p>
                    </div>
                    <div class="help-subheading" style="margin-top: 57px;margin-left: 60px;text-align: left">
                    <span class="main-title-one" style="margin-top: 48px">
                         <a id="login"></a>
                        2.登录
                    </span>
                    </div>
                    <div>
                        <p class="main-content">
                            打开微思翻译首页，点击右上角登录注册按钮，显示登录窗口，使用注册过的账号即可登录。目前支持两种登录方式，用户名密码登录和快捷方式登录。密码登录：使用注册时的用户名+密码，或者注册时的手机号+密码；快捷方式登录：手机号+获取动态验证码。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/login-one.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/login-two.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/login-three.png" alt="">
                    </div>
                    <div>
                        <p class="main-content">
                            说明：机构子账号仅支持在父账号下登录，普通子账号需要登录机构账号再登录子账号，漫游账号可直接登录子账号，在ip范围内的用户也可直接登录子账号，登录过程有问题可联系所在的机构或销售人员。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/login-four.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0;width: 720px;">
                            在登录过程中如果忘记密码，可以通过忘记密码链接找回密码，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/password-one.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0;width: 720px;">
                            在忘记密码弹窗中输入有效手机号获取验证码即可重置密码，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/password-two.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/password-four.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/password-three.png" alt="">
                    </div>
                    <div style="margin-top: 27px">
                        <a id="try"></a>
                        <div class="main-line"></div>
                        <span class="main-title">申请试用</span>
                        <div class="main-line"></div>
                    </div>
                    <div>
                        <p class="main-content" style="text-indent: 0;">
                            本产品支持用户申请试用，在首页点击立即申请试用按钮，在弹窗中填写有效信息，提交申请，稍后会有销售人员联系，为你开通试用账号，试用过程中不收取任何费用。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/try-one.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/try-two.png" alt="">
                    </div>
                    <div style="margin-top: 27px">
                        <a id="suggest"></a>
                        <div class="main-line"></div>
                        <span class="main-title">意见反馈</span>
                        <div class="main-line"></div>
                    </div>
                    <div>
                        <p class="main-content">
                            在试用或使用过程中，对本产品有任何意见或建议都可以随时反馈给我们。在首页、立即翻译页、翻译历史页及阅读翻译文档页，点击意见反馈按钮，输入有效信息提交即可。如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/active.png" alt="">
                    </div>
                    <div style="margin-top: 27px">
                        <a id="translate"></a>
                        <div class="main-line"></div>
                        <span class="main-title">立即翻译</span>
                        <div class="main-line"></div>
                    </div>
                    <div>
                        <p class="main-content">
                            登录机构账号和子账号，点击立即翻译，进入翻译页面。在立即翻译页面会提示子账号上传文档限制及每天可上传文档页数限制，且显示支持上传的文档格式。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate.png" alt="">
                    </div>
                    <div>
                        <p class="main-content">
                            在原文语言选择被翻译文档的语言，在目标语言中选择翻译后的文档语言，也可选择默认的四种语言格式。 如下图所示：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-two.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">选择原语言</span>
                    </div>
                    <div>
                        <img src="../assets/translate-three.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">选择目标语言</span>
                    </div>
                    <div>
                        <img src="../assets/translate-four.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">默认语言选择</span>
                    </div>
                    <div>
                        <p class="main-content" style="height:20px;text-indent: 0px;">
                            上传翻译文档可选择一个，也可选择多个批量上传，但总文档数不能超过10个，总文档大小不能超过20M。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-five.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">上传文档位置</span>
                    </div>
                    <div>
                        <img src="../assets/translate-five.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">上传文档位置</span>
                    </div>
                    <div>
                        <img src="../assets/translate-six.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">上传文档超过10条提示信息</span>
                    </div>
                    <div>
                        <img src="../assets/translate-seven.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">上传文档过程中</span>
                    </div>
                    <div>
                        <img src="../assets/translate-eight.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">上传一个文档完成后</span>
                    </div>
                    <div>
                        <img src="../assets/translate-nine.png" alt="">
                    </div>
                    <div class="title-three-div">
                        <span class="title-three">批量上传多个文档完成后</span>
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            上传完成后，在确认翻译弹窗界面可以修改翻译语言，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-ten.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            上传文档单篇页数超过限制提示，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-eleven.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            上传文档超过个人页数限制提示，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-twelve.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            上传文档超过机构页数限制，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-thirteen.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            上传文档超过机构总页数限制，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-fourteen.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            个人用户暂不支持该业务。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-sixteen.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            个人用户暂不支持该业务。
                        </p>
                    </div>
                    <div>
                        <img src="../assets/translate-sixteen.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 0;text-indent: 0px;color: #df2525">
                            注：上传文档遇到任何问题，可联系所在机构或销售人员。
                        </p>
                    </div>
                    <div style="margin-top: 57px;margin-bottom: 27px">
                        <a id="history"></a>
                        <div class="main-line"></div>
                        <span class="main-title">翻译历史</span>
                        <div class="main-line"></div>
                    </div>
                    <div>
                        <img src="../assets/history.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/history-two.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            待支付的文档，可点击操作下的支付按钮，再次进行交易，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-three.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 40px;text-indent: 0px;">
                            在立即翻译页上传文档后，点击确认翻译后，将跳转到翻译历史页，在翻译历史页显示翻译文档标题，文档的翻译语言，上传文档时间，文档页数，翻译过程中翻译状态，显示翻译中，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-four.png" alt="">
                    </div>
                    <div class="help-reset-margin" style="margin-top: -145px;">
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            翻译完成后，翻译状态显示已翻译，如下图：
                        </p>
                    </div>
                    <div class="help-reset-margin" style="    margin-top: -50px;">
                        <img src="../assets/history-five.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            翻译完成后，可阅读和下载文档，点击操作后的阅读按钮，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-six.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            新页面打开原文档和译文的对比页，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-even.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            在阅读的页面，可下载所需要格式的译文文档，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-eight.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            在阅读页面也可单独阅读译文，单独阅读原文，也可跳转到某一页进行阅读，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-nine.png" alt="">
                    </div>
                    <div>
                        <p class="main-content" style="height: 20px;text-indent: 0px;">
                            如果所在机构余额不足，则在点击确定翻译后会提示，可联系所在机构处理，如下图：
                        </p>
                    </div>
                    <div>
                        <img src="../assets/history-ten.png" alt="">
                    </div>
                </div>
            </div>
        </center>
    </div>
</template>

<script>
    export default {
        name: 'Help',
        methods: {
        }
    }
</script>

<style lang="less" scoped>
    .help-page {
        width: 100%;
        min-width: 0;
        min-height: 100%;
        padding: 22px 0 40px;
        color: #1a1a2e;
        line-height: normal;
        background: #f3f7f9;
        box-sizing: border-box;
        font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
    }

    .help-layout {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        width: calc(100% - 32px);
        max-width: none;
        margin: 0 auto;
        gap: 24px;
    }

    .help-sidebar {
        flex: 0 0 300px;
        padding: 16px 0;
        overflow: hidden;
        border: 1px solid var(--border);
        border-radius: 14px;
        background: #ffffff;
        box-shadow: 0 8px 22px rgba(0, 0, 0, 0.06);
        box-sizing: border-box;
    }

    .help-content {
        flex: 1 1 auto;
        width: calc(100% - 324px);
        min-width: 0;
        padding: 0 36px 40px;
        overflow: hidden;
        border: 1px solid var(--border);
        border-radius: 14px;
        background: #ffffff;
        box-shadow: 0 8px 22px rgba(0, 0, 0, 0.06);
        box-sizing: border-box;
    }

    .help-content img,
    .help-video {
        display: block;
        max-width: 100%;
        height: auto;
        margin-right: auto;
        margin-left: auto;
    }

    .help-video {
        width: 100%;
        max-width: 700px;
        aspect-ratio: 14 / 9;
        border-radius: 12px;
        background: #101828;
    }

    .title-three {
        width: 83px;
        height: 15px;
        font-size: 14px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #666666;
        line-height: 24px;
    }

    .title-three-div {
        margin-bottom: 30px;
        line-height: 0;
    }

    .main-title-one {
        text-align: left;
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: bold;
        color: #2d2d2c;
    }

    .main-content {
        width: 100%;
        max-width: 714px;
        height: auto;
        min-height: 0;
        margin: 14px auto;
        font-size: 14px;
        font-family: "Microsoft YaHei", sans-serif;
        font-weight: normal;
        color: #666666;
        line-height: 1.8;
        text-align: justify;
        text-indent: 2em;
        overflow-wrap: anywhere;
        box-sizing: border-box;
    }

    .main-line {
        width: 20px;
        border: 1px solid #666666;
        opacity: 0.5;
        display: inline-block;
        vertical-align: middle;
    }

    .main-title {
        width: 80px;
        height: 19px;
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #333333;
        line-height: 25px;
    }

    .left-title-two {
        font-size: 14px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #333333;
        line-height: 25px;
    }

    .left-nag-two {
        text-align: left;
        margin-left: 61px;
        cursor: pointer;
    }

    .line {
        width: calc(100% - 24px);
        margin: 0 auto;
        border-top: 1px solid #e4e4e4;
    }

    .left-nag {
        text-align: left;
        margin-left: 40px;
        margin-top: 15px;
        margin-bottom: 15px;
        cursor: pointer;
    }

    .left-title {
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #333333;
        line-height: 25px;
    }

    .help-question {
        max-width: 100%;
        margin-right: auto;
        margin-left: auto;
    }

    .help-question-bubble {
        max-width: calc(100% - 32px);
        box-sizing: border-box;
    }

    .help-content [id] {
        display: block;
        height: 0;
        position: relative;
        top: -88px;
    }

    @media (max-width: 1100px) {
        .main-content,
        .main-content[style] {
            width: 100% !important;
            max-width: 714px;
            height: auto !important;
            min-height: 0 !important;
        }

        .help-question,
        .help-question[style] {
            width: 100% !important;
        }

        .help-reset-margin,
        .help-reset-margin[style] {
            margin-top: 0 !important;
        }
    }

    @media (min-width: 769px) and (max-width: 1100px) {
        .help-layout {
            gap: 16px;
        }

        .help-sidebar {
            flex-basis: 240px;
        }

        .help-content {
            width: calc(100% - 256px);
            padding-right: 24px;
            padding-left: 24px;
        }

        .left-nag {
            margin-left: 28px;
        }
    }

    @media (max-width: 768px) {
        .help-page {
            padding: 0 0 calc(28px + env(safe-area-inset-bottom));
        }

        .help-layout {
            width: 100%;
            display: block;
        }

        .help-sidebar {
            position: sticky;
            z-index: 12;
            top: 56px;
            width: 100%;
            height: auto;
            padding: 10px 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            overflow-x: auto;
            overflow-y: hidden;
            border-width: 0 0 1px;
            border-radius: 0;
            background: rgba(255, 255, 255, 0.97);
            box-shadow: 0 5px 16px rgba(0, 0, 0, 0.08);
            scrollbar-width: none;
        }

        .help-sidebar::-webkit-scrollbar {
            display: none;
        }

        .help-sidebar .line,
        .help-sidebar .left-nag-two {
            display: none;
        }

        .left-nag,
        .left-nag[style] {
            flex: 0 0 auto;
            margin: 0 !important;
            text-align: center;
        }

        .left-nag a {
            min-height: 36px;
            padding: 0 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #526373;
            border: 1px solid #e0e9f2;
            border-radius: 18px;
            background: #f8fbfe;
            white-space: nowrap;
        }

        .left-nag a:active {
            color: #ffffff;
            border-color: var(--primary-dark);
            background: var(--primary-dark);
        }

        .left-title {
            width: auto;
            height: auto;
            font-family: inherit;
            font-size: 13px;
            line-height: 18px;
        }

        .help-content {
            width: calc(100% - 24px);
            margin: 12px auto 0;
            padding: 0 14px 36px;
            overflow: hidden;
            border-radius: 12px;
        }

        .help-content > div {
            max-width: 100%;
        }

        .help-content img {
            width: 100%;
            max-width: 100%;
            margin: 12px auto;
            border: 1px solid var(--border);
            border-radius: 8px;
            box-sizing: border-box;
        }

        .help-video {
            width: 100% !important;
            height: auto !important;
            margin: 12px 0;
            aspect-ratio: 16 / 9;
            border-radius: 8px;
        }

        .main-content,
        .main-content[style] {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            margin: 14px 0 !important;
            padding: 0;
            font-family: inherit;
            font-size: 13px;
            line-height: 1.85;
            overflow-wrap: anywhere;
        }

        .main-title {
            width: auto;
            height: auto;
            color: var(--primary-dark);
            font-family: inherit;
            font-size: 18px;
            font-weight: 700;
        }

        .main-line {
            width: 16px;
            border-color: var(--primary);
        }

        .help-subheading,
        .help-subheading[style] {
            margin-left: 0 !important;
        }

        .main-title-one {
            font-family: inherit;
            font-size: 16px;
        }

        .help-question,
        .help-question[style] {
            width: 100% !important;
            margin: 14px 0;
            display: flex;
            align-items: center;
        }

        .help-question > div:first-child {
            flex: 0 0 auto;
        }

        .help-question-bubble,
        .help-question-bubble[style] {
            width: auto !important;
            max-width: calc(100% - 26px);
            height: auto !important;
            min-height: 45px;
            padding: 10px 12px;
            display: flex !important;
            align-items: center;
            font-family: inherit !important;
            font-size: 12px !important;
            line-height: 1.65 !important;
            text-indent: 0 !important;
            text-align: left !important;
        }

        .help-reset-margin,
        .help-reset-margin[style] {
            margin-top: 0 !important;
        }

        .title-three-div {
            margin-bottom: 18px;
        }

        .help-content [id] {
            top: -116px;
        }
    }
</style>
